import { render } from "./Despedida.vue?vue&type=template&id=a1b52e14&scoped=true&ts=true"
import script from "./Despedida.vue?vue&type=script&lang=ts"
export * from "./Despedida.vue?vue&type=script&lang=ts"

import "./Despedida.vue?vue&type=style&index=0&id=a1b52e14&lang=scss&scoped=true"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1b52e14"]])

export default __exports__